export function getConfig() {
    return {
        domain: "https://powerfactors-production.eu.auth0.com",
        provider: "powerfactors-production.eu.auth0.com",
        clientId: "xxnn8rFq9eG4C14jR3tshpOx3OOBZPMX",
        connection: "salesforce"
    }
}